"use client"

import { ExploreItem } from "@src/components/ExploreItem"
import { useConnectWallet } from "@src/hooks/useConnectWallet"
import { usePromotionStanding } from "../hooks/usePromotionStanding"
import {
  formatPromotionRank,
  type PromotionStanding,
} from "../lib/promotionStanding"

export function PromotionExploreItem() {
  const { state } = useConnectWallet()
  const accountId = state.isAuthorized ? state.address : undefined
  const { standing } = usePromotionStanding(accountId)
  const copy = getPromotionExploreCopy(standing)

  return (
    <ExploreItem
      item={{
        title: copy.title,
        description: copy.description,
        href: "/near-x",
        illustrationVariant: "green",
        illustration: (
          <div className="flex w-52 shrink-0 flex-col gap-4 rounded-t-lg bg-gray-800 p-4 dark:bg-gray-850">
            <div className="h-3 w-2/3 rounded bg-white/10" />
            <div className="flex items-center gap-0.5">
              <div className="h-1 flex-1 rounded-[1px] bg-green-500" />
              <div className="h-3 w-1 rounded-[1px] bg-white" />
              <div className="h-1 flex-1 rounded-[1px] bg-white/10" />
              <div className="h-3 w-1 rounded-[1px] bg-white" />
            </div>
          </div>
        ),
      }}
    />
  )
}

function getPromotionExploreCopy(standing: PromotionStanding): {
  title: string
  description: string
} {
  if (standing.kind === "not-applied") {
    return {
      title: "Join NEAR@3.33, earn rewards",
      description: "333,333 NEAR, shared across everyone who qualifies.",
    }
  }
  if (standing.kind === "applied") {
    return {
      title: "Track your NEAR@3.33 rewards",
      description: formatPromotionRank(standing.stats),
    }
  }
  if (standing.kind === "syncing") {
    return {
      title: "Track your NEAR@3.33 rewards",
      description: "Your stats are syncing. Check back soon.",
    }
  }
  if (standing.phase === "standing") {
    return {
      title: "Track your NEAR@3.33 rewards",
      description:
        standing.kind === "loading"
          ? "Checking your standing…"
          : "Your standing is temporarily unavailable.",
    }
  }
  return {
    title:
      standing.kind === "loading"
        ? "Checking your NEAR@3.33 status"
        : "Explore NEAR@3.33 rewards",
    description:
      standing.kind === "loading"
        ? "Checking whether you've joined…"
        : "We couldn't check your promotion status.",
  }
}
